// extracted by mini-css-extract-plugin
export default {"Container":"SubscriptionCard_Container__2T7d8","Unsubscribe":"SubscriptionCard_Unsubscribe__i0uRe"};